<template>
  <div>
    <navigation-bar :hasNoBg="true"></navigation-bar>

    <div v-if="loading" class="flex justify-center items-center p-10">
      <span>Loading...</span>
    </div>

    <div v-else class="container mx-auto p-4 md:p-10 lg:p-[100px]">
      <!-- Event Image -->
      <div>
        <img
          class="w-full h-96 object-cover"
          :src="eventsData.image_path"
          alt="Event Image"
        />
      </div>

      <!-- Main Content and Recently/Relative Events Section -->
      <div class="flex mt-8 space-x-10">
        <!-- Event Title and Content -->
        <div class="flex-1">
          <h1 class="text-[20px] md:text-[24px] lg:text-[30px] font-bold">
            {{ getLocalized(eventsData, "title") }}
          </h1>
          <p
            class="text-[16px] lg:text-[20px] text-gray-600 mt-4"
            v-html="formatContent(getLocalized(eventsData, 'content'))"
          ></p>
        </div>
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
import NavigationBar from "../../view/NavigationBar.vue";
import footerView from "@/view/footerView.vue";

export default {
  components: { NavigationBar, footerView },
  props: ["id"],
  data() {
    return {
      itemID: null,
      api: process.env.VUE_APP_API_KEY,
      eventsData: {}, // Store the event data
      loading: true, // Loading state for data fetching
      error: null, // Error state for handling API issues
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    this.getEventData();
  },
  methods: {
    formatContent(content) {
      if (!content) return ""; // Return empty if no content

      // Trim any extra spaces around the content
      let formattedContent = "";
      let tempContent = content.trim();

      // Split content by period (.) or Khmer full stop (។)
      const sentences = tempContent.split(/(?<=\.|។)/); // Split by period or Khmer full stop

      let line = "";
      sentences.forEach((sentence) => {
        const sentenceWithDot = sentence.trim(); // Ensure sentence ends with a period or full stop

        // If line length is under 500 characters, add to the current line
        if (line.length + sentenceWithDot.length <= 500) {
          line += sentenceWithDot + " "; // Add space after sentence
        } else {
          // Otherwise, add the current line to formattedContent and start a new line
          formattedContent += line.trim() + "<br><br>";
          line = sentenceWithDot + " "; // Start new line with the current sentence
        }
      });

      // Add any remaining content in the last line
      if (line.length > 0) {
        formattedContent += line.trim();
      }

      return formattedContent; // Return the formatted content with <br> tags
    },
    async getEventData() {
      try {
        this.itemID = this.id;

        const { data } = await axios.get(
          `${this.api}/api/events/${this.itemID}`
        );
        this.eventsData = {
          ...data,
          image_path: `${this.api}${data.image_path}`, // Append base URL to image path
        };
      } catch (error) {
        console.error("Error fetching event data:", error);
        this.error = "Failed to load event data. Please try again later.";
      } finally {
        this.loading = false; // Set loading state to false after data fetching
      }
    },
  },
};
</script>

<style scoped>
/* Optional: Add custom styles or layout tweaks */
.container {
  max-width: 1200px;
}
</style>
